import { DateRangePickerProps } from "@amzn/awsui-components-console";

export enum RELATIVE_OPTION_KEYS {
  PAST_24_HOURS = "past-24-hours",
  PAST_WEEK = "past-week",
  PAST_MONTH = "past-month",
  PAST_6_MONTHS = "past-6-months",
  PAST_YEAR = "past-year",
  PAST_10_YEARS = "past-10-years",
}

export const RELATIVE_RANGE_STRINGS: { [key: string]: string } = {
  [RELATIVE_OPTION_KEYS.PAST_24_HOURS]: "Past 24 Hours",
  [RELATIVE_OPTION_KEYS.PAST_WEEK]: "Past Week",
  [RELATIVE_OPTION_KEYS.PAST_MONTH]: "Past Month",
  [RELATIVE_OPTION_KEYS.PAST_6_MONTHS]: "Past 6 Months",
  [RELATIVE_OPTION_KEYS.PAST_YEAR]: "Past Year",
  [RELATIVE_OPTION_KEYS.PAST_10_YEARS]: "Past 10 Years",
};

export const RELATIVE_OPTIONS: DateRangePickerProps.RelativeOption[] = [
  {
    key: RELATIVE_OPTION_KEYS.PAST_24_HOURS,
    amount: 1,
    unit: "day",
    type: "relative",
  },
  {
    key: RELATIVE_OPTION_KEYS.PAST_WEEK,
    amount: 7,
    unit: "day",
    type: "relative",
  },
  {
    key: RELATIVE_OPTION_KEYS.PAST_MONTH,
    amount: 1,
    unit: "month",
    type: "relative",
  },
  {
    key: RELATIVE_OPTION_KEYS.PAST_6_MONTHS,
    amount: 6,
    unit: "month",
    type: "relative",
  },
  {
    key: RELATIVE_OPTION_KEYS.PAST_YEAR,
    amount: 1,
    unit: "year",
    type: "relative",
  },
  {
    key: RELATIVE_OPTION_KEYS.PAST_10_YEARS,
    amount: 10,
    unit: "year",
    type: "relative",
  },
];
